export class User {
    public id!: string;
    public first_name: string;
    public last_name: string;
    public email!: string;
    public redmine_login!: string;
    public status!: string;
    public avatar: string;
    public created_on!: Date;
    public time_entry_role: CollaborationRole;
    public memberships: Array<ProjectMembership>;
    public redanka_roles: Array<string>;
    public logged_in: boolean;

    constructor() {
        this.first_name = '';
        this.last_name = '';
        this.avatar = '';
        this.time_entry_role = 'other';
        this.memberships = [];
        this.redanka_roles = [];
        this.logged_in = false;
    }
}

export class ProjectMembership {
    public project: { id: string; name: string } | undefined;
    public roles: Array<{ id: string; name: string }>;

    constructor() {
        this.roles = [];
    }
}

const collaborationRoles = ['employee', 'consultant', 'external', 'other'] as const;

type CollaborationRole = typeof collaborationRoles[number];